import { Modal } from "@mantine/core";
import { useMemo } from "react";

type Props = {
	error: Error | null;
	onClose: () => void;
};

export function ErrorModal({ error, onClose }: Props): React.JSX.Element {
	const isOpen = useMemo(() => {
		return error !== null;
	}, [error]);

	return (
		<Modal
			className="error-modal"
			title="Er ging iets mis"
			opened={isOpen}
			onClose={onClose}
		>
			<p>{error?.message}</p>
		</Modal>
	);
}
